var Socket = function() {
    this.now = Date.now()

    if (location.host.indexOf('mobcpop.com') !== -1) {
        ios = new Client({ url: 'wss://s.mobcpop.com:8080', longLiveFlash: true })
    } else {
        ios = new Client({ url: 'ws://' + location.hostname + ':3001', longLiveFlash: true })
    }

    ios.on('reconnect', function(a, b) {
        pageUnmount()
        var room = window.room && window.room.id

        window.login(null, function() {
            if (room && room != '') {
                emit({
                    id: 'room join',
                    room_id: room,
                    boobs: true,
                })
            } else {
                emit({
                    id: 'room leave',
                })
            }
            emit({ id: 'boobs' })
        })
    })
    ios.on('r', function() {
        window.location.reload()
    })
    ios.on('g', function(data) {
        location.href = data
    })
    ios.on('gr', function(data) {
        location.replace(data)
    })
    ios.on('gb', function(data) {
        history.back()
    })
    ios.on('cp', function(data) {
        pageUnmount()
    })
}